<template lang="pug">
  .related-products
    icon-button.related-products__prev(
      v-if="'mobile' !== $mq"
      label="Next Slide",
      icon="chevron-left-big",
      size="64px"
      @click="$refs.productImageCarousel.slidePrev()"
    )
    icon-button.related-products__next(
      v-if="'mobile' !== $mq"
      label="Previous Slide",
      icon="chevron-right-big",
      size="64px"
      @click="$refs.productImageCarousel.slideNext()"
    )
    carousel(
      ref="productImageCarousel",
      :infinite="true"
      :center-mode="true"
      :dots="['mobile', 'tablet'].includes($mq)"
      :slides-to-show="['mobile', 'tablet'].includes($mq) ? 1.5 : 3"
    )
      slot
</template>

<script>
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import Carousel from 'scripts/components/basic/Carousel.vue';

  export default {
    name: 'ProductRelated',
    components: {
      IconButton,
      Carousel,
    }
  };
</script>

<style lang="scss">
  .related-products {
    position: relative;
    padding: 0 #{24px + $grid-gutter * 2};

    @include mobile-only {
      padding: 0 #{$grid-gutter * 1.5};
      max-width: 550px;
      margin-left: auto;
      margin-right: auto;
    }

    &__next,
    &__prev {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      .icon {
        fill: $color-indigo;
      }
    }

    &__next {
      right: 15px;

      @include mobile-only {
        right: 4px;
      }
    }

    &__prev {
      left: 15px;

      @include mobile-only {
        left: 4px;
      }
    }
  }
</style>
